import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  templateKey: string;
};

const [useApplyProductTypeTemplate, applyProductTypeTemplate] = createAsyncAction(
  "productTypes/applyTemplate",
  async ({ spaceId, templateKey }: Args) => {
    const res = await API.call<{ productType: string }>({
      endpoint: `spaces/${spaceId}/product-types/apply-template`,
      method: "POST",
      data: {
        template_key: templateKey,
      },
    });
    return { ...res, result: res.result.productType };
  }
);

export default useApplyProductTypeTemplate;
export { applyProductTypeTemplate };
